import React from 'react';
import { CalendarCheck, Menu, Users } from 'lucide-react';

export type ClinicianTab = 'MyDay' | 'Patients' | 'Menu';

export interface ClinicianBottomNavProps {
  active: ClinicianTab;
  onSelect: (tab: ClinicianTab) => void;
}

/**
 * Phone bottom navigation for clinicians outside a patient chart (plan §6.2). 64 px targets;
 * the chart has its own PatientBottomNav. Respects the iPhone home indicator.
 */
const ClinicianBottomNav: React.FC<ClinicianBottomNavProps> = ({ active, onSelect }) => {
  const items: { id: ClinicianTab; label: string; icon: React.ReactNode }[] = [
    { id: 'MyDay', label: 'My Day', icon: <CalendarCheck size={22} /> },
    { id: 'Patients', label: 'Patients', icon: <Users size={22} /> },
    { id: 'Menu', label: 'Menu', icon: <Menu size={22} /> },
  ];
  return (
    <nav
      aria-label="Main"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-gray-200 bg-white"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {items.map((it) => (
        <button
          key={it.id}
          type="button"
          aria-current={active === it.id ? 'page' : undefined}
          onClick={() => onSelect(it.id)}
          className={`flex h-16 flex-col items-center justify-center gap-0.5 text-xs font-medium ${active === it.id ? 'text-slate-900' : 'text-gray-500'}`}
        >
          {it.icon}{it.label}
        </button>
      ))}
    </nav>
  );
};

export default ClinicianBottomNav;
